import { useTranslation } from 'next-i18next';
import React from 'react';
import { BoothLogosComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import Image from 'next/image';

const BoothLogos = ({ uiComponent }: UiComponentElementInterface<BoothLogosComponentInterface>) => {
  const { t } = useTranslation();

  const booths = useSelector((state) => state.common.booths);
  const event = useSelector((state) => state.common.event);

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <div
        className={`w-full`}
        style={{
          color: uiComponent?.styling?.textColor || '#000',
        }}>
        {booths && booths?.length > 0 ? (
          <div className="grid @sm:grid-cols-3 @xs:grid-cols-2 @md:grid-cols-4 gap-8 @md:mt-8 text-center text-sm @md:text-lg">
            {booths?.map((booth: any) => (
              <div className="flex flex-col" key={`booth-${booth?._id}`} id={`booth-${booth?._id}`}>
                {uiComponent?.showBoothLogo && (
                  <div className="flex justify-center">
                    <div className="relative size-36">
                      <Image
                        fill
                        alt="exhibitor logo"
                        className="rounded-2xl object-contain @md:mb-3"
                        src={createDisplayLink(booth.logo, true, 250, 250, 100)}
                      />
                    </div>
                  </div>
                )}
                <div className="text-center break-normal">
                  {booth.name} {event?.settings?.useBoothNumber ? (booth.boothnumber ? `[${booth.boothnumber}]` : '') : ''}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <EmptyComponent componentName={t('pagebuilder:booth-logo-list')} />
        )}
      </div>
    </>
  );
};

export default BoothLogos;
